import { viewContainer } from "helpers/redux";
import FormBody from "./body";

export default viewContainer(FormBody, "trackerLogs");
